import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { getAccountVerifiedHtml } from '@/controller/auth';

const EmailVerificationPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const token = searchParams.get('token');
        const email = searchParams.get('email');
        const tenant = searchParams.get('tenant');

        const fetchHtml = async () => {
            try {
                if (tenant) {
                    localStorage.setItem('tenants_id', tenant);
                }
                const response = await getAccountVerifiedHtml(tenant, email, token);
                const htmlString =
                    response && response.data
                        ? response.data
                        : '<p style="text-align: center; margin-top: 2rem; font-family: sans-serif;">Verification failed. Invalid response.</p>';

                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');

                document.head.innerHTML = doc.head.innerHTML;
                document.body.innerHTML = doc.body.innerHTML;
            } catch (error) {
                console.error(error);
                const parser = new DOMParser();
                const doc = parser.parseFromString(
                    '<p style="text-align: center; margin-top: 2rem; font-family: sans-serif;">An error occurred during verification.</p>',
                    'text/html',
                );
                document.head.innerHTML = doc.head.innerHTML;
                document.body.innerHTML = doc.body.innerHTML;
            } finally {
                setLoading(false);
            }
        };

        fetchHtml();
    }, [searchParams]);

    if (loading) {
        return (
            <div className="flex h-screen w-screen items-center justify-center bg-white">
                <div className="text-gray-500 font-sans">Verifying account...</div>
            </div>
        );
    }

    return null;
};

export default EmailVerificationPage;
